import Challenge from "@/modules/activities/challenge/components/challenges"
import type { Location } from "react-router-dom"
import { Navigate, useLocation, useParams } from "react-router-dom"

export interface ChallengeIdPageState {
  name: string
  course: string
  id: string
}

export default function ChallengeIdPage() {
  const location: Location<ChallengeIdPageState> = useLocation()
  const { id } = useParams<{ id: string }>()

  if (!id || !location.state) {
    return <Navigate to="/activities/challenge/notFound" replace />
  }

  return (
    <div className="flex min-h-screen w-full">
      <Challenge
        course={location.state.course}
        name={location.state.name}
        id={id}
        userActivityId={location.state.id}
      />
    </div>
  )
}
